import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { Button, Form, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  setChangeFieldValue,
  updateProjectCode,
} from "../../../../../redux/slices/others/projectCodeSlice";
import numeral from "numeral";

import Icon from "@mdi/react";
import { mdiCheckBold } from "@mdi/js";

const CodeEditingList = () => {
  const dispatch = useDispatch();

  const {
    selectMinistry,
    selectDepartment,
    rmkValue,
    ministry,
    programs,
    mainProjects,
    ministries,
    departments,
    isLoading,
  } = useSelector((state) => ({
    ministry: state.projectCodeReducer.ministry,
    programs: state.utilsReducer.dropdownItems.programs,
    mainProjects: state.utilsReducer.dropdownItems.mainProjects,
    ministries: state.utilsReducer.dropdownItems.ministries,

    rmkValue: state.utilsReducer.rmkValue,
    selectMinistry: state.projectCodeReducer.selectMinistry,
    selectDepartment: state.projectCodeReducer.selectDepartment,

    isLoading: state.projectCodeReducer.isLoading,
  }));

  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [programOptions, setProgramOptions] = useState([]);
  const [mainProjectOptions, setMainProjectOptions] = useState([]);

  const [totalCost, setTotalCost] = useState(0);
  const [totalCeiling, setTotalCeiling] = useState(0);

  const handleChangeFieldName = (obj, value, fieldName) => {
    const props = {
      project_id: obj.id,
      field_name: fieldName,
      value: value,
    };
    dispatch(setChangeFieldValue(props));
  };

  const handleSaveRow = (obj) => {
    const newValues = {
      ministry_id: obj?.ministry_with_label?.code,
      department_id: obj?.department_with_label?.id,
      program_id: obj?.program_with_label?.id,
      main_project_id: obj?.main_project?.id,
      code: obj?.code,
      name: obj?.name,
    };

    const params = {
      project_id: obj.uuid,
      ministry_id: selectMinistry,
      department: selectDepartment,
      rmk_id: rmkValue?.number,
      new_values: newValues,
    };

    dispatch(updateProjectCode(params));
  };

  const handleSaveAll = (obj) => {
    const params = {
      rmk_id: rmkValue?.number,
      department: selectDepartment,
      ministry_id: selectMinistry,
      updated_projects: ministry?.projects,
      is_change_all: "all",
    };
    dispatch(updateProjectCode(params));
  };

  useEffect(() => {
    if (isEmpty(ministry)) return;
    const filteredPrograms = programs
      ?.filter(
        (obj) => obj.ministry_code.toString() === ministry?.code.toString(),
      )
      .map((obj) => ({
        ...obj,
        label: `${obj.code} ${obj.name}`,
        value: `${obj.code} ${obj.name}`,
      }));

    setProgramOptions(filteredPrograms);

    const filteredMainProjects = mainProjects?.filter(
      (obj) => obj?.ministry_id?.toString() === ministry?.code.toString(),
    );
    setMainProjectOptions(filteredMainProjects);

    const departments = ministry.departments?.map((obj) => ({
      ...obj,
      label: `${obj.code} ${obj.label}`,
      value: `${obj.code} ${obj.label}`,
    }));

    setDepartmentOptions(departments);

    const sumCost =
      ministry.projects
        .flatMap((obj) => obj.financial_details)
        ?.reduce((acc, obj) => acc + parseFloat(obj.cost_required), 0) || 0;

    const sumCeiling =
      ministry.projects
        ?.flatMap((obj) => obj.financial_details)
        ?.flatMap((obj) => obj.ceiling_flow_details)
        ?.reduce((acc, obj) => acc + parseFloat(obj.amount), 0) || 0;

    setTotalCost(sumCost);
    setTotalCeiling(sumCeiling);
  }, [ministry, programs, mainProjects]);

  return (
    <>
      <div className='table-responsive mb-3'>
        <Table hover size='sm' style={{ width: 2000 }}>
          <thead
            className='text-uppercase custom-table-head'
            style={{ fontSize: 12 }}
          >
            <tr>
              <th />
              <th className='text-center'>#</th>
              <th style={{ width: 112 }}>Kod Kementerian</th>
              <th>Kod Jabatan</th>
              <th>Kod Program</th>
              <th>Kod Projek Utama</th>
              <th>Kod Sub Projek</th>
              <th>Nama Projek</th>
              <th className='text-center'>Kos Diluluskan</th>
              <th className='text-center'>Siling Diluluskan</th>
            </tr>
          </thead>
          <tbody>
            {ministry?.projects?.map((obj, idx) => {
              const budget = obj.financial_details;
              const costApproved =
                budget.reduce(
                  (acc, item) => acc + parseFloat(item.cost_required),
                  0,
                ) || 0;
              const ceilingApproved =
                budget
                  .flatMap((item) => item.ceiling_flow_details)
                  ?.reduce((acc, item) => acc + parseFloat(item.amount), 0) ||
                0;

              const filteredMainProjectOptions = mainProjects?.filter(
                (item) => item.program_id === obj?.program_with_label?.id,
              );

              return (
                <tr key={obj.id}>
                  <td className='text-center'>
                    <Button
                      variant='success'
                      onClick={() => handleSaveRow(obj)}
                      disabled={isLoading}
                    >
                      <Icon path={mdiCheckBold} size={0.5} />
                    </Button>
                  </td>
                  <td className='text-center'>{idx + 1}</td>
                  <td>
                    <Select
                      isSearchable
                      placeholder='Pilih Kementerian'
                      isDisabled={isLoading}
                      options={ministries}
                      value={obj?.ministry_with_label || null}
                      onChange={(value) =>
                        handleChangeFieldName(obj, value, "ministry_with_label")
                      }
                      noOptionsMessage={() => "Tiada pilihan"}
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                      menuPortalTarget={document.body}
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          borderColor: "#ced4da",
                          backgroundColor: state.isDisabled
                            ? "#e2e8ee"
                            : "#FFF",
                        }),
                        singleValue: (baseStyles, state) => ({
                          ...baseStyles,
                          color: state.isDisabled
                            ? "rgb(84, 84, 84)"
                            : "#495057", // Change text color to black when disabled
                        }),
                        placeholder: (baseStyles, state) => ({
                          ...baseStyles,
                          color: state.isDisabled
                            ? "rgb(84, 84, 84)"
                            : "#495057", // Change placeholder color to black when disabled
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999, // bring to front
                        }),
                        menu: (base) => ({
                          ...base,
                          width: "300px",
                        }),
                      }}
                    />
                  </td>
                  <td>
                    <Select
                      isSearchable
                      placeholder='Pilih Agensi Pelaksana (Kod Jabatan)'
                      isDisabled={isLoading}
                      options={departmentOptions || []}
                      value={obj?.department_with_label || null}
                      onChange={(value) =>
                        handleChangeFieldName(
                          obj,
                          value,
                          "department_with_label",
                        )
                      }
                      noOptionsMessage={() => "Tiada pilihan"}
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                      menuPortalTarget={document.body}
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          borderColor: "#ced4da",
                          backgroundColor: state.isDisabled
                            ? "#e2e8ee"
                            : "#FFF",
                        }),
                        singleValue: (baseStyles, state) => ({
                          ...baseStyles,
                          color: state.isDisabled
                            ? "rgb(84, 84, 84)"
                            : "#495057", // Change text color to black when disabled
                        }),
                        placeholder: (baseStyles, state) => ({
                          ...baseStyles,
                          color: state.isDisabled
                            ? "rgb(84, 84, 84)"
                            : "#495057", // Change placeholder color to black when disabled
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999, // bring to front
                        }),
                        menu: (base) => ({
                          ...base,
                          width: "300px",
                        }),
                      }}
                    />
                  </td>
                  <td>
                    <Select
                      isSearchable
                      placeholder='Pilih Program'
                      isDisabled={isLoading}
                      options={programOptions}
                      value={obj?.program_with_label || null}
                      onChange={(value) =>
                        handleChangeFieldName(obj, value, "program_with_label")
                      }
                      noOptionsMessage={() => "Tiada pilihan"}
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                      menuPortalTarget={document.body}
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          borderColor: "#ced4da",
                          backgroundColor: state.isDisabled
                            ? "#e2e8ee"
                            : "#FFF",
                        }),
                        singleValue: (baseStyles, state) => ({
                          ...baseStyles,
                          color: state.isDisabled
                            ? "rgb(84, 84, 84)"
                            : "#495057", // Change text color to black when disabled
                        }),
                        placeholder: (baseStyles, state) => ({
                          ...baseStyles,
                          color: state.isDisabled
                            ? "rgb(84, 84, 84)"
                            : "#495057", // Change placeholder color to black when disabled
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999, // bring to front
                        }),
                      }}
                    />
                  </td>
                  <td>
                    <Select
                      isSearchable
                      placeholder='Pilih Projek Utama'
                      isDisabled={isLoading}
                      options={filteredMainProjectOptions}
                      value={obj?.main_project || null}
                      onChange={(value) =>
                        handleChangeFieldName(obj, value, "main_project")
                      }
                      noOptionsMessage={() => "Tiada pilihan"}
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                      menuPortalTarget={document.body}
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          borderColor: "#ced4da",
                          backgroundColor: state.isDisabled
                            ? "#e2e8ee"
                            : "#FFF",
                        }),
                        singleValue: (baseStyles, state) => ({
                          ...baseStyles,
                          color: state.isDisabled
                            ? "rgb(84, 84, 84)"
                            : "#495057", // Change text color to black when disabled
                        }),
                        placeholder: (baseStyles, state) => ({
                          ...baseStyles,
                          color: state.isDisabled
                            ? "rgb(84, 84, 84)"
                            : "#495057", // Change placeholder color to black when disabled
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999, // bring to front
                        }),
                      }}
                    />
                  </td>
                  <td>
                    <Form.Group className='w-100'>
                      <Form.Control
                        name='name'
                        type='text'
                        disabled={isLoading}
                        autoComplete='off'
                        value={obj.code}
                        onChange={(e) => {
                          const value = e.target.value;
                          handleChangeFieldName(obj, value, "code");
                        }}
                        style={{ height: 38 }}
                      />
                    </Form.Group>
                  </td>
                  <td style={{ width: 370 }}>
                    <Form.Group className='w-100'>
                      <Form.Control
                        as='textarea'
                        type='text'
                        disabled={isLoading}
                        autoComplete='off'
                        value={obj.name}
                        onChange={(e) => {
                          const value = e.target.value;
                          handleChangeFieldName(obj, value, "name");
                        }}
                        style={{ height: 80, maxHeight: 120 }}
                      />
                    </Form.Group>
                  </td>
                  <td className='text-end' style={{ width: 200 }}>
                    {numeral(costApproved).format("0,0.00")}
                  </td>
                  <td className='text-end' style={{ width: 200 }}>
                    {numeral(ceilingApproved).format("0,0.00")}
                  </td>
                </tr>
              );
            })}
            <tr>
              <td colSpan={8} className='text-end'>
                Jumlah
              </td>
              <td className='text-end'>
                {numeral(totalCost).format("0,0.00")}
              </td>
              <td className='text-end'>
                {numeral(totalCeiling).format("0,0.00")}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
      <div className='d-flex justify-content-end'>
        <Button variant='success' onClick={handleSaveAll} disabled={isLoading}>
          Simpan Keseluruhan
        </Button>
      </div>
    </>
  );
};

export default CodeEditingList;
